import { guid } from '../../../../../../alan_btn/src/helpers/mini/guid';
import { ITransform, ITransformRow } from '../../../../models/ITransform';
import { getEmptyTransform } from './getTransformText';

export function getTransformFromText(text: string) {
    const defaultRow = { editing: true, id: guid(), visible: true } as ITransformRow;
    let transform = {
        rows: [
            { ...defaultRow, rowIndex: 0 }
        ]
    } as ITransform;
    try {
        if (text) {
            transform = JSON.parse(text);
            transform.rows = transform.rows?.map((r, i) => {
                return { ...r, id: guid(), rowIndex: i, visible: true };
            });

            if (transform.rows?.length === 0) {
                transform.rows.push(defaultRow);
            }
            const defaultConfig = getEmptyTransform().config;
            transform.config = {
                maxTokens: transform?.config?.maxTokens ?? defaultConfig.maxTokens,
                iq: transform?.config?.iq ?? defaultConfig.iq,
                temperature: transform?.config?.temperature ?? defaultConfig.temperature,
            };
        }
        return transform;
    } catch (error) {

    }

    return transform;
}